// import React from "react";
// import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";

// const RefurbishedProductGridBoxOEM = ({ itemin, issold,view }) => {
//   return (
//     <>
//       <div className="product-card product-card--layout--grid d-flex bg-white position-relative rounded overflow-hidden">
//         {/* Main product content */}
//         <div className="w-100">
//           <div className="product-card__image rounded">
//             <div className="image image--type--product rounded">
//               <a
//                 href={`/oem-category/${itemin?.catSlug}/${itemin?.subCatSlug}/${itemin?.slug}`}
//                 className="image__body rounded"
//               >
//                 <img
//                   alt=""
//                   className="image__tag rounded"
//                   src={itemin?.image}
//                 />
//               </a>
//             </div>
//           </div>
//           <div className="product-card__info mt-2">
//             <div className="product-card__name">
//               <a
//                 href={`/oem-category/${itemin?.catSlug}/${itemin?.subCatSlug}/${itemin?.slug}`}
//                 className="fw-bold f14"
//               >
//                 {itemin?.name}
//               </a>
//             </div>
//             <div className="mt-2 ps-3 pe-3 text-truncate text-primary fw500 f12">
//               {itemin?.manufacture?.name && <> {itemin?.manufacture?.name}</>}
//             </div>
//           </div>

//           {itemin?.price && itemin?.price !== "0.00" && (
//             <span className="btn btn-sm bglblue mb-1 mt-2 ps-2 pe-2 d-flex align-items-center f15 fw500">
//               <CurrencyRupeeIcon className="f14 fw-bold" />
//               {itemin?.price}
//             </span>
//           )}

//             <div className="d-flex justify-content-center">
//               {issold ? (
//                 <div className="border border-dark rounded  text-center w-90 text-black my-2 ps-3 pe-3 py-2 f16" style={{background:"#c8c8c8"}}>
//                   Sold Out
//                 </div>
//               ) : (
//                 <a
//                   href={`/oem-category/${itemin?.catSlug}/${itemin?.subCatSlug}/${itemin?.slug}`}
//                   className="border border-dark rounded bg-white text-center w-90 text-black my-2 ps-3 pe-3 py-2 f16"
//                 >
//                   View Details
//                 </a>
//               )}
//             </div>

//         </div>

//         {/* Overlay only when sold */}
//         {issold && (
//           <div
//             className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-end align-items-center"
//             style={{ backgroundColor: "#f0f0f0",opacity:"0.5" }}
//           >
//             {/* <div className="w-100 bg-secondary text-white fw-bold text-center py-2">
//               Sold Out
//             </div> */}
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default RefurbishedProductGridBoxOEM;

import React from "react";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { UnderWarrantyIcon, WarrantyBadge } from "../icon";
import { Link } from "react-router-dom";

const RefurbishedProductGridBoxOEM = ({ itemin, issold, view }) => {
  const productUrl = `/hi-value-plus/product-detail/${itemin?.productSlug}`;
  console.log("object", itemin);

  return (
    <div
      className={`hiproduct-card d-flex bg-white position-relative rounded overflow-hidden h-100 ${view === "grid"
        ? "flex-column text-center higrid-view"
        : "flex-column flex-lg-row flex-md-row py-4 p-2 hilist-view"
        }`}
    >
      <div className="position-relative">
        {itemin?.soldOut === 1 && (
          <div
            className="position-absolute text-white bgred rounded-1 px-2 z-3"
            style={{
              opacity: "1",
              top: view === "grid" ? "10px" : "80%",
              left: "10px",
            }}
          >
            Sold Out
          </div>
        )}
        {itemin?.warranty === 1 && (
          <div
            className="position-absolute object-fit-contain text-white rounded-1 px-2 z-3
                       warranty-badge-wrapper"
            style={{
              top: view === "grid" ? "10px" : "0%",
              right: view === "grid" ? "10px" : "0px",
            }}
          >
            <WarrantyBadge
              months={itemin?.warrantyMonths}
              color={itemin?.soldOut === 1 ? "#ff000097" : "#FF0000"}
              size={60}
            />
          </div>
        )}
        {/* <div
          className="f10 position-absolute"
          style={{
            bottom: view === "grid" ? "10px" : "0px",
            left: "10px",
            display: view === "grid" ? "block" : "none",
          }}
        >
          Posted On : {itemin?.postedOn}{" "}
        </div> */}
        {/* IMAGE */}
        <div
          className={`hiproduct-card__images rounded ${view === "grid" ? "w-100" : "w-100 me-3"
            }`}
        >
          <a href={productUrl} className="d-block h-100">
            <img
              alt={itemin?.name}
              className="img-fluid rounded w-100 h-100"
              src={itemin?.coverImage}
            />
          </a>
        </div>
      </div>

      {/* INFO */}
      <div
        className={`hiproduct-card__info ${view === "grid"
          ? "mt-2 text-start w-100"
          : "d-flex flex-column flex-lg-row flex-md-row justify-content-between w-100"
          }`}
      >
        <div>
          {/* Name */}
          <div className="hiproduct-card__name">
            <a
              href={`/hi-value-plus/product-detail/${itemin?.productSlug}`}
              className="  d-flex flex-column align-items-start align-items-md-center align-items-lg-center flex-lg-row flex-md-row gap-1"
            >
              {itemin?.name}   <span className="hispan txtlgeay fw-normal">(Refurbished Product)</span>
            </a>
          </div>
          <a
            href={`/hi-value-plus/product-detail/${itemin?.productSlug}`}
            className="hicategoryspan txtlgeay d-flex align-items-center gap-1 px-3"
          >
            {itemin?.categoryName}
          </a>

          {/* Manufacture */}
          {itemin?.dealerName && (
            <div className="text-primary fw500 hicategoryspan mt-0 mt-lg-2  text-truncate px-3">
              {itemin?.dealerName.length > 25
                ? itemin?.dealerName.slice(0, 25) + "..."
                : itemin?.dealerName}{" "}
              | {itemin?.city}
            </div>
          )}

          {/* Price */}
          {itemin?.price && itemin?.price !== "0.00" && (
            <div className="btn btn-sm  ps-3 pe-2 d-flex flex-column align-items-start align-items-md-center align-items-lg-center flex-lg-row flex-md-row hiproductprice fw500">
              <span className="d-flex align-items-center">

                <CurrencyRupeeIcon className="hiproductprice fw-bold " />
                {itemin?.price}
              </span>
              <span className="hiproductpricegst txtlgeay ms-1">(inclusive of GST)</span>
            </div>
          )}
          {/* <div
            className="hiproductprice d-flex align-items-center px-3 "
            style={{
              bottom: view === "grid" ? "10px" : "0px",
              // left: "10px",
              // display: view === "grid" ? "block" : "none",
            }}
          >
            Posted On : {itemin?.postedOn}{" "}
          </div> */}
        </div>

        {/* Action Button */}
        <div
          className={`${view === "grid"
            ? " mt-2 px-3 mb-3 w-100"
            : "d-flex  justify-content-start flex-column h-auto"
            }`}
        >
          <Link to={itemin?.soldOut === 1 ? "#" : productUrl}>
            <div

              className={`${view === "grid" ? "border" : ""
                } ps-3 pe-3 py-2 hiproductprice  hivalueplussectionBtn d-flex justify-content-center`}
            >
              View Details
            </div>
          </Link>
          {/* {view !== "grid" && (
            <div className="f12">Posted On : {itemin?.postedOn} </div>
          )} */}
        </div>
      </div>
      {itemin?.soldOut === 1 && (
        <div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{ backgroundColor: "#f0f0f0", opacity: "0.5" }}
        ></div>
      )}
    </div>
  );
};

export default RefurbishedProductGridBoxOEM;
